module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/question-square.svg?941edc282b8760f3699a994e7169cdc1";